import { useStatsOrdersOverviewToday } from "../../api/hooks/stats";

function TodaysOverview() {
  const { data } = useStatsOrdersOverviewToday();
  return (
    <div className="flex flex-col gap-4 rounded-xl border-2">
      <div className="flex rounded-t-xl bg-[#D1DFFF] px-6 py-1">
        <div className="flex gap-2 text-lg">
          <div>Today's Overview</div>
        </div>
      </div>
      <div className="flex gap-6 divide-x overflow-auto px-6 pb-4">
        <div className="flex flex-col items-center justify-around divide-y">
          <p className="flex flex-grow items-center text-nowrap font-bold">
            OUTBOUND
          </p>
          <p className="flex flex-grow items-center text-nowrap font-bold">
            INBOUND
          </p>
        </div>
        <div className="flex flex-grow flex-col gap-6 divide-y pl-6">
          <div className="flex justify-center gap-6 px-6">
            <div className="text-center">
              <p>Outstanding Order</p>
              <p className="text-lg font-bold">
                {data?.outbound?.new?.count || 0}
              </p>
              <p>{data?.outbound?.new?.quantity || 0} Qty</p>
            </div>
          </div>
          <div className="flex justify-center gap-6 px-6 pt-6">
            <div className="text-center">
              <p>Outstanding Order</p>
              <p className="text-lg font-bold">
                {data?.inbound?.new?.count || 0}
              </p>
              <p>{data?.inbound?.new?.quantity || 0} Qty</p>
            </div>
          </div>
        </div>
        <div className="flex flex-grow flex-col gap-6 divide-y pl-6">
          <div className="flex justify-center gap-6 px-6">
            <div className="text-center">
              <p>Scheduled Today</p>
              <p className="text-lg font-bold">
                {data?.outbound?.outbound?.count || 0}
              </p>
              <p>{data?.outbound?.outbound?.quantity || 0} Qty</p>
            </div>
          </div>
          <div className="flex justify-center gap-6 px-6 pt-6">
            <div className="text-center">
              <p>Scheduled Today</p>
              <p className="text-lg font-bold">
                {data?.inbound?.expected?.count || 0}
              </p>
              <p>{data?.inbound?.expected?.quantity || 0} Qty</p>
            </div>
          </div>
        </div>
        <div className="flex flex-grow flex-col gap-6 divide-y pl-6">
          <div className="flex justify-center gap-6 px-6">
            <div className="text-center">
              <p>Sent Today</p>
              <p className="text-lg font-bold">
                {data?.outbound?.sent?.count || 0}
              </p>
              <p>{data?.outbound?.sent?.quantity || 0} Qty</p>
            </div>
          </div>
          <div className="flex justify-center gap-6 px-6 pt-6">
            <div className="text-center">
              <p>Received Today</p>
              <p className="text-lg font-bold">
                {data?.inbound?.arrived?.count || 0}
              </p>
              <p>{data?.inbound?.arrived?.quantity || 0} Qty</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TodaysOverview;
